var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.143 11.486a1 1 0 0 0 .343 1.372L10 14.966V15a2 2 0 1 0 1.029-1.749l-3.514-2.108a1 1 0 0 0-1.372.343Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 14C2 8.477 6.477 4 12 4s10 4.477 10 10v2.214A2.786 2.786 0 0 1 19.214 19h-2.34A5.99 5.99 0 0 1 12 21.5 5.99 5.99 0 0 1 7.127 19H4.786A2.786 2.786 0 0 1 2 16.214V14Zm6.29 3H4.787A.786.786 0 0 1 4 16.214V14a8.001 8.001 0 0 1 7-7.938V7a1 1 0 1 0 2 0v-.938A8.004 8.004 0 0 1 19.938 13H19a1 1 0 1 0 0 2h1v1.214a.786.786 0 0 1-.786.786H15.71a4.001 4.001 0 0 1-7.418 0Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionSpeed);
export default __webpack_public_path__ + "static/media/ic_action_speed.6c9bf8a75c166796ec93103ed3f295a1.svg";
export { ForwardRef as ReactComponent };